export const UNKNOWN = "unknown";
export const POTENTIAL_BUYER = "potentialbuyer";
export const OWNER = "owner";
export const BUYER = "buyer";
export const SELLER = "seller";
export const TENANT = "tenant";
export const FOLLOWER = "follower";
